/*
 * サブシステム名：支払
 * 機能名：支払備考入力（ダイアログ）
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButton from '@/components/DdIconButton'
import DdTextArea from '@/components/DdTextArea'
import flowMixin from '@/mixins/flowMixins'

export default {
  name: 'ShiharaiBikoEditDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdIconButton,
    DdTextArea
  },
  props: {
    showDialog: Boolean,
    id: 0,
    shiharaiKihon: {},
    modeKengen: 0
  },
  data: () => ({
    invalidMessages: {}
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isShoukaiMode () {
      return this.modeKengen === 0
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0) {
        return true
      }
      return false
    }
  },
  methods: {
    onCloseButtonClick: function (e) {
      this.$emit('close')
    },
    onSaveButtonClick: function (e) {
      const isValid = this.validateAll(this.$refs)
      if (!isValid) { return }

      return new Promise(resolve => {
        this.HttpClient.put(`/api/v1/TrShiharaiKihon/Update?id=${this.id}`, this.shiharaiKihon)
          .then((data) => {
            this.$emit('close', data)
            resolve()
          })
      })
    }
  }
}
